import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  TouchableWithoutFeedback,
  Keyboard,
} from 'react-native';
import * as Auth from 'aws-amplify/auth';
import Toast from 'react-native-root-toast';

import AppTextInput from '../components/AppTextInput';
import AppButton from '../components/AppButton';
import alert from '../components/alert';
import Util from '../util/util.js';
import Header from '../components/Header';
import Footer from '../components/Footer.js';
import styles from '../style/screens/forgotPasswordInternalStyles';
import { useFormValidation, validateEmail } from '../util/validation/formValidator';
import { useResponsiveStyles } from '../hooks';
import { useTranslation } from '../i18n';

const ForgotPasswordInternal = (props) => {
  const { t } = useTranslation('auth');

  const { organization, admin, userAdmin } = props.route.params;

  // Use responsive styles hook for platform detection
  const { isWeb, containerStyle } = useResponsiveStyles();

  const [userFontSize, setUserFontSize] = useState(24);

  // Form validation using centralized hook
  const {
    values,
    isValid,
    setDisplayErrors,
    setFieldValue,
    getFieldError,
  } = useFormValidation(
    { email: '' },
    { email: [validateEmail] }
  );

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    const user = await Auth.fetchUserAttributes();
    setFieldValue('email', user.email);
  };

  useEffect(() => {
    setUserFontSize(Util.calculateFontSize(values.email, 48, userFontSize));
  }, [values.email]);

  async function handleForgotPassword() {
    setDisplayErrors(true);
    if (!isValid) {
      return;
    }

    try {
      await Auth.resetPassword({ username: values.email });
      Toast.show(`✅ ${t('forgot.codeSent')}`, {
        backgroundColor: '#259e23',
        duration: 5000,
        textColor: '#fff',
      });

      props.navigation.navigate('ResetPassword', {
        organization: organization,
        admin: admin,
        userAdmin: userAdmin,
        authenticatedEmail: values.email,
      });
    } catch (error) {
      console.log(
        '❌ Verification code does not match. Please enter a valid verification code.',
        error.toString(),
      );
      alert(t('common:actions.error'), '❌' + error.toString());
    }
  }
  return (
    <View
      style={[
        containerStyle,
        styles.safeAreaContainer,
      ]}
    >
      <Header organization={organization} admin={admin} userAdmin={userAdmin} type="pop" />
      <TouchableWithoutFeedback
        onPress={!isWeb ? Keyboard.dismiss : () => {}}
        accessible={false}
      >
        <View style={styles.container}>
          <Text style={styles.title}>{t('forgot.confirmEmail')}</Text>
          <AppTextInput
            value={values.email}
            onChangeText={(text) => setFieldValue('email', text)}
            leftIcon="account"
            placeholder={t('forgot.enterEmailPlaceholder')}
            autoCapitalize="none"
            keyboardType="email-address"
            textContentType="emailAddress"
            style={{ fontSize: userFontSize, width: '100%' }}
            error={getFieldError('email')}
          />
          <AppButton title={t('forgot.sendPasswordResetCode')} isEnabled={isValid} onPress={handleForgotPassword} />
        </View>
      </TouchableWithoutFeedback>
      <Footer admin={admin} organization={organization} userAdmin={userAdmin} />
    </View>
  );
};

export default ForgotPasswordInternal;
